import script from "./PremiumNumbersCategory.vue?vue&type=script&lang=ts&setup=true"
export * from "./PremiumNumbersCategory.vue?vue&type=script&lang=ts&setup=true"

import "./PremiumNumbersCategory.vue?vue&type=style&index=0&id=e1b646f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1b646f4"]])

export default __exports__